import React, { useReducer } from 'react'
import { t } from 'i18next';
import { logout } from '../../services/login';
import { createSectorService, deleteSectorService, editSectorService, getListOfSectorsService } from '../../services/Settings';
import { CLEAN_SECTORS_ERROR, CLEAN_SECTORS_STATE, CRUD_SECTORS, GET_SECTORS, SET_SECTORS_DATA } from './types';
import SectorsManagementReducer from './SectorsManagementReducer';
import SectorsManagementContext from './SectorsManagementContext';

const SectorsManagementState = ({ children }) => {

    const initialState = {
        sectorsToConfig: [],
        sectorData: {
            sectorId: '',
            sectorName: '',
            sectorEnabled: 1,
        },
        isFetching: false,
        error: {
            ok: false,
            text: ''
        },
        responseSectorsService: {
            show: false,
            type: '',
            text: '',
        }
    }

    const [state, dispatch] = useReducer(SectorsManagementReducer, initialState);

    const setFetching = (value) => {
        dispatch({
            type: 'SET_FETECHING',
            payload: value
        });
    }

    const getSectorsManagement = async (text, enabled) => {
        try {
            setFetching(true);
            const enabledParam = enabled ? `sectorEnabled=${enabled ? enabled : ''}` : '';
            const textParam = text ? `&searchText=${text ? text : ''}` : '';

            const param = `${enabledParam}${textParam}`;

            const items = await getListOfSectorsService(param);
            if (enabled) {
                items.data.response.push({
                    "sectorId": null,
                    "sectorName": t('WITHOUT_SECTOR'),
                    "sectorEnabled": 0
                })
            }
            if (items.ok) {
                dispatch({
                    type: GET_SECTORS,
                    payload: {
                        sectorsToConfig: items.data.response,
                        responseSectorsService: {
                            show: false,
                            type: 'SUCCESS',
                            text: '',
                        }
                    }
                })
            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: GET_SECTORS,
                    payload: {
                        sectorsToConfig: state.sectorsToConfig,
                        responseSectorsService: {
                            show: true,
                            type: 'ERROR',
                            text: errorMsg,
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: GET_SECTORS,
                payload: {
                    resources: state.sectorsToConfig,
                    responseSectorsService: {
                        show: true,
                        type: 'ERROR',
                        text: t('SERVER_ERROR'),
                    }
                }
            });
        }
    }

    const getSector = async (id) => {
        try {
            setFetching(true);

            const param = id ? `sectorId=${id}` : '';

            const items = await getListOfSectorsService(param);

            if (items.ok) {
                setSectorsData(items.data.response[0])
                return items.data.response[0]
            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: GET_SECTORS,
                    payload: {
                        sectorsToConfig: state.sectorsToConfig,
                        responseSectorsService: {
                            show: true,
                            type: 'ERROR',
                            text: errorMsg,
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: GET_SECTORS,
                payload: {
                    resources: state.sectorsToConfig,
                    responseSectorsService: {
                        show: true,
                        type: 'ERROR',
                        text: t('SERVER_ERROR'),
                    }
                }
            });
        }
    }

    const createSector = async (sector) => {
        try {
            setFetching(true);

            const items = await createSectorService(sector);

            if (items.ok) {
                dispatch({
                    type: CRUD_SECTORS,
                    payload: {
                        responseSectorsService: {
                            show: true,
                            type: 'SUCCESS',
                            text: `${t('SECTOR')} ${t('CREATED_SUCCESSFULLY')}`,
                        }
                    }
                })

            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('NAME_ALREADY_EXIST');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: CRUD_SECTORS,
                    payload: {
                        responseSectorsService: {
                            show: true,
                            type: 'ERROR',
                            text: errorMsg
                        },
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: CRUD_SECTORS,
                payload: {
                    responseSectorsService: {
                        show: true,
                        type: 'ERROR',
                        text: t('SERVER_ERROR')
                    },
                }
            });
        }
    }

    const editSector = async (sector) => {
        try {
            setFetching(true);

            const items = await editSectorService(sector);

            if (items.ok) {
                dispatch({
                    type: CRUD_SECTORS,
                    payload: {
                        responseSectorsService: {
                            show: true,
                            type: 'SUCCESS',
                            text: `${t('SECTOR')} ${t('EDITED_SUCCESSFULLY')}`,
                        }
                    }
                })
            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('SECTOR_USED_ERROR');
                        break;
                    case 'CONCURRENCY_ERROR':
                        errorMsg = t('NAME_ALREADY_EXIST');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: CRUD_SECTORS,
                    payload: {
                        responseSectorsService: {
                            show: true,
                            type: 'ERROR',
                            text: errorMsg,
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: CRUD_SECTORS,
                payload: {
                    responseSectorsService: {
                        show: true,
                        type: 'ERROR',
                        text: t('SERVER_ERROR'),
                    }
                }
            });
        }
    }

    const deleteSector = async (query) => {
        try {
            setFetching(true);

            const items = await deleteSectorService(query);

            if (items.ok) {
                dispatch({
                    type: CRUD_SECTORS,
                    payload: {
                        responseSectorsService: {
                            show: true,
                            type: 'SUCCESS',
                            text: `${t('SECTOR')} ${t('DELETED_SUCCESSFULLY')}`,
                        }
                    }
                })

            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('SECTOR_USED_ERROR');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: CRUD_SECTORS,
                    payload: {
                        responseSectorsService: {
                            show: true,
                            type: 'ERROR',
                            text: errorMsg,
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: CRUD_SECTORS,
                payload: {
                    responseSectorsService: {
                        show: true,
                        type: 'ERROR',
                        text: t('SERVER_ERROR'),
                    }
                }
            });
        }
    }

    const cleanSectorsState = () => {
        dispatch({
            type: CLEAN_SECTORS_STATE,
        });
    }

    const removeWarningModal = (type) => {
        dispatch({
            type: CLEAN_SECTORS_ERROR,
        });
    }

    const setSectorsData = (sector) => {
        dispatch({
            type: SET_SECTORS_DATA,
            payload: sector
        });
    }

    return (
        <SectorsManagementContext.Provider
            value={{
                sectorsManagementState: state,
                getSectorsManagement,
                createSector,
                editSector,
                deleteSector,
                cleanSectorsState,
                removeWarningModal,
                setSectorsData,
                getSector
            }}
        >
            {children}
        </SectorsManagementContext.Provider>
    )
}

export default SectorsManagementState